import React from 'react';
import { useUser } from '../../contexts/UserContext';
import { useOnboardingData } from '../../hooks/useOnboardingData';
import { useOnboardingCalculations } from '../../hooks/useOnboardingCalculations';
import OnboardingWidgetView from './OnboardingWidgetView';
import MotivationalLoader from '../MotivationalLoader';

interface OnboardingWidgetContainerProps {
  customerId: string;
}

const OnboardingWidgetContainer: React.FC<OnboardingWidgetContainerProps> = ({ customerId }) => {
  const { user } = useUser();
  const {
    loading,
    error,
    onboardingData,
    updating,
    authError,
    loadOnboardingData,
    handleTaskStatusChange,
    retryAuth,
  } = useOnboardingData(customerId, user);

  const {
    progressPercentage,
    completedTasksCount,
    taskStats,
    milestoneReached,
  } = useOnboardingCalculations(onboardingData);

  if (loading) {
    return (
      <div className="onboarding-widget loading">
        <MotivationalLoader type="onboarding" size="md" />
      </div>
    );
  }

  if (error || !onboardingData) {
    return (
      <div className="onboarding-widget error">
        <p className="error-message">{error || 'Something went wrong'}</p>
        {authError ? (
          <button onClick={retryAuth} className="retry-button">
            Sign In Again
          </button>
        ) : (
          <button onClick={() => loadOnboardingData()} className="retry-button">
            Retry
          </button>
        )}
      </div>
    );
  }

  return (
    <OnboardingWidgetView
      onboardingData={onboardingData}
      progressPercentage={progressPercentage}
      completedTasksCount={completedTasksCount}
      taskStats={taskStats}
      milestoneReached={milestoneReached}
      updating={updating}
      onTaskStatusChange={handleTaskStatusChange}
    />
  );
};

export default OnboardingWidgetContainer;